import $ from "jquery"

// Handle see more button
$('.ct-see-more').on('click', function() {
    const getLinkedSection = $('section.ct-about-event').offset().top;
    window.scrollTo(0, getLinkedSection);
});